module.exports = __webpack_public_path__ + "static/img/bio-lgchem.ba92f80.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/bio-lgchem.jpg
// module id = ACwl
// module chunks = 0